export default __webpack_public_path__ + "static/media/sticker-A.8722ee4b.png";